import React from 'react';
/**
 * `NavBar` renders the site header containing the brand logo.
 *
 * The logo is wrapped in a home link (`/`) so keyboard and screen-reader users
 * can always navigate back to the start. The logo URL is sourced from CMS
 * content (`content.common.navLogoUrl`).
 */
import { useAppSelector } from '../../app-state/Hooks';

const NavBar = React.memo(function NavBar(): JSX.Element {
  const content = useAppSelector((s) => s.content);

  const logoUrl = content?.common?.navLogoUrl ?? '';

  return (
    <header className='navbar flex-row nav-bar-container'>
      <a href='/' className='navbar-brand'>
        <img
          src={logoUrl}
          alt='logo'
          className='nav-logo'
        />
      </a>
    </header>
  );
});

export default NavBar;
